import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import Typography from "@/shared/components/common/Typography";

interface FlightCardTagsProps {
  tags: string[];
}

export default function FlightCardTags({ tags }: FlightCardTagsProps) {
  return (
    <Flex
      alignItems={"center"}
      justifyContent={"end"}
      gap={"2"}
      className="flex-wrap"
    >
      <List
        items={tags}
        renderItems={(tag) => (
          <Flex.Item className="bg-muted dark:bg-muted/10 ring-1 ring-border rounded-full px-3">
            <Typography
              variant={"caption"}
              className="text-grayColor-foreground"
            >
              {tag}
            </Typography>
          </Flex.Item>
        )}
      />
    </Flex>
  );
}
